import { render, staticRenderFns } from "./TelcoFormStock.vue?vue&type=template&id=5b21c4c7&"
import script from "./TelcoFormStock.vue?vue&type=script&lang=ts&"
export * from "./TelcoFormStock.vue?vue&type=script&lang=ts&"
import style0 from "./TelcoFormStock.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports